import React, { useState, useEffect } from 'react';
import { Card, Col, Nav, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import Avatar from "../../components/Avatar";
import UsersKPI from '../../components/UsersKPI';
import OrdersKPI from '../../components/OrdersKPI';
import CouponsKPI from '../../components/CouponsKPI';
import ProductsKPI from '../../components/ProductsKPI';
import RevenueKPI from '../../components/RevenueKPI';
import axios from '../../api/axios';
import OutletRevenueKpi from '../../components/OutletRevenueKpi';
import AllTimeKPI from '../../components/AllTimeKPI';
import CustomerReturnTime from './CustomerReturnTime';
import AOVInsight from './AOV/AOVInsight';
import CustomerDropOffInsightDetails from './CustomerDropOffInsightDetails';
import CustomerDropOffInsight from './CustomerDropOffInsight';
import CategoriesInsight from './CategoriesInsight';
import ItemRepeatInsight from './ItemRepeatInsight';
import SalesTrendInsight from './SalesTrendInsight';
import OrdersInsight from './OrdersInsight';
import OutletMapInsight from './Outlet/OutletMapInsight';
import OutletInsight from './Outlet/OutletInsight';
import FeedbackInsight from './Feedback/FeedbackInsight';
import axiosInstance from '../../api/axios';

const SmartInsightsList = () => {
  const [outlets, setOutlets] = useState([]);
  const [outletFilter, setOutletFilter] = useState('all');
  const [loadingOutlets, setLoadingOutlets] = useState(false);
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  useEffect(() => {
    getOutlets();
  }, []);

  const getOutlets = async () => {
    try {
      setLoadingOutlets(true);
      const token = localStorage.getItem('authToken');
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axiosInstance.get('outlet', { headers });
      if (response?.data?.status === true) {
        const filteredOutlets = response?.data?.data?.outlets?.filter(out => out?.status === 'ACTIVE');
        // setOutlets(response?.data?.data?.outlets);
        setOutlets(filteredOutlets);
      }
    } catch (error) {
      console.error('Error fetching outlets:', error);
    } finally {
      setLoadingOutlets(false);
    }
  };

  return (
    <React.Fragment>
        {/* <div className='mt-4'>
          <CustomerReturnTime />
        </div> */}
        {/* <div className='mt-4'>
          <AOVInsight />
        </div>
        <div className='mt-4'>
          <CustomerDropOffInsight />
        </div>
        <div className='mt-4'>
          <CategoriesInsight />
        </div>
        <div className='mt-4'>
          <ItemRepeatInsight />
        </div>
        <div className='mt-4'>
          <SalesTrendInsight />
        </div>
        <div className='mt-4'>
          <OrdersInsight />
        </div> */}

        <div className='mt-2'>
          <OutletMapInsight />
        </div>

        {/* <div className='mt-2'>
          <OutletInsight />
        </div> */}
        
        <div className='mt-4'>
          <FeedbackInsight />
        </div>
    </React.Fragment>
  );
};

export default SmartInsightsList;